import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.top_up.success.title',
        defaultMessage: 'Top up successful',
    },
    subtitle: {
        id: 'modal.top_up.success.subtitle',
        defaultMessage: 'Done! <span>{amount} {currency}</span> transferred from your wallet to your card.',
    },
    button: {
        id: 'modal.top_up.success.button',
        defaultMessage: 'Close',
    },
})
